<template>
  <div
    :id="idPopover"
    :data-cy="dataCyId"
    :data-question-id="dataQuestionId"
    :tabindex="0"
    :class="`${classes} tw-cursor-pointer action-button tw-relative ${
      isFromNotification ? 'tw-px-[0px]' : 'tw-p-[20px]'
    }`"
    @mouseleave="$emit('on-hover', false)"
    @click="openModal(!showMoreActions)"
  >
    <span
      :class="{
        'three-dots-wrapper tw-cursor-pointer': true,
        '!tw-cursor-not-allowed': disabled,
        iconClass: iconClass,
      }"
    >
      <slot v-if="hasSlot('icon')" name="icon" />
      <svg
        v-else
        width="21"
        height="5"
        viewBox="0 0 23 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="2.5"
          cy="2.54562"
          r="2.5"
          :fill="isFromNotification ? '#B7B7B7' : '#878787'"
        />
        <circle
          cx="11.5"
          cy="2.54562"
          r="2.5"
          :fill="isFromNotification ? '#B7B7B7' : '#878787'"
        />
        <circle
          cx="20.5"
          cy="2.54562"
          r="2.5"
          :fill="isFromNotification ? '#B7B7B7' : '#878787'"
        />
      </svg>
    </span>
  </div>
  <CustomDropDown
    v-if="!disabled"
    :id-popover="idPopover"
    :class="[
      !showMoreActions || !overrideHover ? 'tw-invisible' : '',
      dropdownClass,
    ]"
    :custom-class="customClass"
    :show-acction-click="true"
    :placement="placement"
    @click="openModal(false)"
  >
    <template v-if="showMoreActions" #default>
      <slot />
    </template>
  </CustomDropDown>
</template>

<script lang="ts">
import { onBeforeUnmount, Ref, ref } from "vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import CustomDropDown from "../customDropDown.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

@Component({
  emits: ["on-hover"],
  components: { CustomDropDown },
})
export default class ButtonShowMore extends Vue {
  @Prop({ required: true }) idPopover = "";
  @Prop({ required: false }) isFromNotification = "";
  @Prop({ required: false, default: "" }) classes = "";
  @Prop({ required: false, default: "" }) dropdownClass = "";
  @Prop({ required: false, default: "" }) customClass = "";
  @Prop({ required: false, default: "" }) iconClass = "";
  @Prop({ required: false, default: false }) disabled = false;
  @Prop({ required: false, default: "bottom-start" }) placement = "";
  @Prop({ required: false, default: false }) dataCyId = "";
  @Prop({ required: false, default: false }) dataQuestionId = "";

  public showMoreActions: Ref | any = ref(true);
  public overrideHover = true;

  public openModal = (value) => {
    this.showMoreActions.value = value;
    if (value) {
      EventEmitter.emit(EmitterEvents.CLOSE_GLOBAL_SEARCH);
    }
  };

  onHoverIn() {
    if (!this.hasSlot("icon")) return;
    const backdrop = document.getElementById("switcher-backdrop");
    if (backdrop) {
      this.openModal(false);
      return;
    }
    this.openModal(true);
    this.$emit("on-hover", true);
    EventEmitter.emit(EmitterEvents.CLOSE_GLOBAL_SEARCH);
  }

  handleClickOutside(event: MouseEvent) {
    const button = document.getElementById(this.idPopover);
    const popover = document.querySelector(".b-popover");
    if (
      button &&
      !button.contains(event.target as Node) &&
      popover &&
      !popover.contains(event.target as Node)
    ) {
      this.showMoreActions = false;
    }
  }

  closeIfNotActive(idPopover: string) {
    try {
      // if (this.idPopover !== idPopover && this.hasSlot("icon")) {
      //   this.overrideHover = false;
      // } else {
      //   this.overrideHover = true;
      // }
      this.openModal(false);
    } catch (error) {
      return error;
    }
  }

  mounted() {
    this.showMoreActions = false;
    window.addEventListener("click", this.handleClickOutside);
    EventEmitter.on(EmitterEvents.CLOSE_ALL_POPOVERS, (idPopover: unknown) => {
      this.closeIfNotActive(idPopover as string);
    });
  }

  beforeUnmount() {
    EventEmitter.off(EmitterEvents.CLOSE_ALL_POPOVERS);
    window.removeEventListener("click", this.handleClickOutside);
  }

  hasSlot(name: string) {
    return !!this.$slots[name];
  }
}
</script>

<style lang="scss" scoped>
.action-button {
  display: flex;
  justify-content: center;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  // margin: -8px;
}
.table,
.current-roles-table {
  .action-button {
    // padding: 10px 20px;
  }
}
.custom-actions-popover .popover-arrow {
  width: 14px;
  height: 14px;
}

.custom-actions-popover.bs-popover-bottom {
  margin-top: unset;
  .popover-arrow {
    top: -8px;
  }
}

.custom-actions-popover.bs-popover-top {
  .popover-arrow {
    bottom: -8px;
  }
}

.popover {
  border: none !important;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.popover-body {
  border: none !important;
  padding: 0 !important;
  min-width: 160px;
}

.decorator-modal-more {
  transform: rotate(45deg);
  width: 20px;
  height: 20px;
  background: white;
  position: absolute;
  top: -8px;
  left: 20px;
}
</style>
